document.addEventListener('DOMContentLoaded', function() {
  Localization.init();
});

const Localization = {
  popupDismissKey: 'regionChangePopupDismissed',

  isModalExcludedPath: function(pathname) {
    const segments = (pathname || '').toLowerCase().split('/').filter(Boolean);
    return segments.includes('blogs') || segments.includes('pages');
  },

  hasActiveDismissal: function() {
    try {
      return sessionStorage.getItem(this.popupDismissKey) === 'true';
    } catch (e) {
      return false;
    }
  },

  setDismissal: function() {
    try {
      sessionStorage.setItem(this.popupDismissKey, 'true');
    } catch (e) {
      // Ignore errors
    }
  },

  checkStoreRouting: function() {
    const { shopUrl, marketHandle } = window.SelkirkStore || {};
    if (!shopUrl || !marketHandle) return;

    if (this.isModalExcludedPath(window.location.pathname)) {
      return;
    }

    const isAsiaStore = shopUrl.includes('selkirk-asia') || shopUrl.includes('asia.selkirk.com');
    const isAsiaMarket = marketHandle.includes('asia-3pl-countries');
    const isROWMarket = marketHandle.includes('rest-of-world');

    // On Asia store but Shopify resolved them to ROW → bounce to main store
    if (isAsiaStore && isROWMarket) {
      if (this.hasActiveDismissal()) return;
      Localization.showStorePrompt();
      return;
    }

    // On main store but IP suggests Asia market → prompt to switch, once per session
    if (!isAsiaStore && isAsiaMarket) {
      if (this.hasActiveDismissal()) return;
      Localization.showStorePrompt();
    }
  },

  showStorePrompt: function() {
    const { shopUrl, countryName } = window.SelkirkStore || {};
    const backdrop = document.getElementById('region-change-modal-backdrop');
    const modal = document.getElementById('region-change-modal');
    const title = document.getElementById('region-change-modal-title');
    const body = document.getElementById('region-change-modal-body');
    const stayBtn = document.getElementById('region-change-modal-stay');
    const continueBtn = document.getElementById('region-change-modal-continue');

    if (!backdrop || !modal || !stayBtn || !continueBtn) {
      console.warn('Region change modal elements not found in DOM.');
      return;
    }

    const isAsiaStore = shopUrl && (shopUrl.includes('selkirk-asia') || shopUrl.includes('asia.selkirk.com'));
    const country = countryName || 'your region';

    if (isAsiaStore) {
      title.textContent = 'WELCOME TO SELKIRK ASIA';
      body.textContent = `It looks like you're browsing from ${country}. Selkirk Asia only ships within Asia-Pacific, so you won't be able to complete a purchase here. Please visit selkirk.com to place your order.`;
      stayBtn.textContent = 'Stay anyway';
      continueBtn.textContent = 'Go to selkirk.com';
    } else {
      title.textContent = 'WELCOME TO SELKIRK';
      body.innerHTML = `It looks like you're browsing from ${country}. Switch to <strong>Selkirk Asia</strong> for faster delivery and lower shipping costs`;
      stayBtn.textContent = 'Stay on selkirk.com';
      continueBtn.textContent = 'Go to Selkirk Asia';
    }

    const close = () => {
      backdrop.classList.remove('is-open');
      modal.classList.remove('is-open');
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.onclick = null;
      stayBtn.onclick = null;
      continueBtn.onclick = null;
    };

    backdrop.classList.add('is-open');
    modal.classList.add('is-open');
    backdrop.setAttribute('aria-hidden', 'false');

    backdrop.onclick = () => {
      close();
      this.setDismissal();
    };

    stayBtn.onclick = () => {
      close();
      this.setDismissal();
    };

    continueBtn.onclick = () => {
      this.setDismissal();
    };
  },

  init: async function() {
    // 0. Handle cross-store routing before anything else
    this.checkStoreRouting();
  }
};